/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
    name: 'generic_prod',
    production: true,
    apiUrl: 'https://ion.ioncontracts.com/api',
    socketsUrl: 'http://ec2-54-209-98-49.compute-1.amazonaws.com:8081',
    socketsApiUrl: 'wss://ec2-54-209-98-49.compute-1.amazonaws.com:8081/ws',
    defaultRealmId: null,
    calendlyEventUrl: 'https://calendly.com/jeff-ives/ion-training',
    googleMapsApiKey: 'AIzaSyBWpsuhmTgZN_bvRGlSbEG1RWtEqtcTRkU',
};
